module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_2_2-4c759b811451929db2c9c169facfb7fd.png";